import { config } from 'util/config';
import * as globalFunction from 'util/GlobalFunction';

const DAYS_BEFORE_DUE_DATE_TITLE = 'Days Before Due Date';
const DAYS_AFTER_DUE_DATE_TITLE = 'Days After Due Date';

function setDaysBeforeDueDateTitle(pageComponent, componentType, autoNotificationTypeId) {
  globalFunction.setUieTitle(
    pageComponent,
    'AutoNotification',
    componentType,
    'DaysBeforeDueDate',
    autoNotificationTypeId === 6 ? DAYS_AFTER_DUE_DATE_TITLE : DAYS_BEFORE_DUE_DATE_TITLE
  );
}

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });
  sectionComponent.customForm.current?.setState({ componentDefaultValue: [], componentDataSource: [] });
  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

export function autoNotificationTypeChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  setDaysBeforeDueDateTitle(pageComponent, sectionComponent.state.componentType, parameter);
  switch (parameter) {
    case 1:
    case 2:
    case 4:
    case 7:
      globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'DaysBeforeDueDate', true);
      globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'WorkflowStatusId', false);
      globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'JobStatusFollowUpDays', false);
      break;
    case 3:
      globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'DaysBeforeDueDate', false);
      globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'WorkflowStatusId', true);
      globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'JobStatusFollowUpDays', true);
      break;
    case 5:
      globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'DaysBeforeDueDate', false);
      globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'WorkflowStatusId', false);
      globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'JobStatusFollowUpDays', true);
      break;
    case 6:
      globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'DaysBeforeDueDate', true);
      globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'WorkflowStatusId', false);
      globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'JobStatusFollowUpDays', false);
      break;
  }
}

export function addAutoNotificationPopUpRun({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  setDaysBeforeDueDateTitle(pageComponent, sectionComponent.state.componentType, null);
  globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'DaysBeforeDueDate', true);
  globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'WorkflowStatusId', false);
  globalFunction.setUieVisible(pageComponent, 'AutoNotification', sectionComponent.state.componentType, 'JobStatusFollowUpDays', false);
}

export function cancelCustomForm({ parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.setState({ showModal: false, customFormSubmitting: false, isFormModified: false, componentType: null });
  setTimeout(() => {
    sectionComponent.customForm.current?.setState({ componentDefaultValue: [], componentDataSource: [] });
    sectionComponent.customForm.current?.resetFields();
  }, config.setTimeoutMilliSecond);
}
